import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import IconShow from "canvas-core-react/lib/IconShow";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";

import FilterComponent from "../../utils/searchBar";
import Modal from "../../utils/customModal";
import {
  formatResponse,
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../utils/functions";
import useApi from "../../hooks/useApi";
import Table from "../../shared/table";
import Checkbox from "../../shared/custom-components/checkbox";
import { EXECUTE, MOD_DISCONT_PROV } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useHistory } from "react-router";

const ProviderAditionalModify = () => {
  const { t } = useTranslation();
  const { getApiCAll, cancellCall, postApiCAll } = useApi();

  const [menu, setMenu] = useState([]);
  const [data, setData] = useState({});
  const [query, setQuery] = useState("");
  const [allSelect, setAllSelect] = useState(new Set());
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const roles = useSelector((state) => getRoles(state));
  const [pagination, setPagination] = useState({ page: 0, sizePerPage: 10 });
  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  const history = useHistory();

  const filters = [
    {
      name: "Nombre",
      property: "provider.institution.companyName",
      operator: "eq",
    },
    {
      name: "Identificación",
      property: "provider.institution.businessId",
      operator: "eq",
    },
  ];

  useEffect(() => {
    setMenu([]);

    const { page, sizePerPage } = pagination;
    getList({ page, sizePerPage });

    return () => {
      cancellCall();
    };
  }, []);

  const getList = ({ page, sizePerPage, querystring = null }) => {
    setLoading(true);

    let queryString = querystring !== null ? querystring : query;
    return getApiCAll(
      `/providers/company/modify-additional-account-list?page=${page}&size=${sizePerPage}${queryString}`
    )
      .then((response) => {
        setData(response.data.data);
        setQuery(queryString);
        setPagination({ page, sizePerPage });
        setLoading(false);
      })
      .catch(console.error);
  };

  const handleMenu = (id, open) => {
    const tmpMenu = [...menu];
    if (open === false) {
      setMenu([]);
    } else {
      tmpMenu[`menu-${id}`] = open;
      setMenu(tmpMenu);
    }
  };

  const getModalResponse = (data) => {
    let button = { formBtn: { text: "Continuar", action: closeAndReset } };
    let content = sucessInfoModal(
      "Adiciones/Modificaciones",
      formatResponse(data.data),
      button
    );
    setModal({ show: true, content, onClose: closeAndReset });
  };

  const closeAndReset = () => {
    closeModal();
  };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const getHeaders = () => {
    const { page } = pagination;
    let headers = [];

    if (moduleAction(roles, MOD_DISCONT_PROV, EXECUTE)) {
      headers.push({
        grow: 0,
        selector: "checkbox",
        name: (
          <Checkbox
            id={`checkbox-${page}`}
            label=""
            name="checkbox"
            onChange={(e) => selectAll(e.target.checked, `page-${page}`)}
            checked={allSelect.has(`page-${page}`)}
          />
        ),
        center: true,
        bodyStyle: { flexGrow: 0 },
        cellFormatter: (row) => {
          if (row.item.requestType != "ADDITION") {
            return (
              <Checkbox
                id={`checkbox-${row.item.id}`}
                label=""
                name="checkbox"
                onChange={(e) =>
                  changeSelection(e.target.checked, `id-${row.item.id}`)
                }
                checked={selected.has(`id-${row.item.id}`)}
              />
            );
          } else {
            return "";
          }
        },
      });
    }

    headers.push(
      { selector: "company", name: t("providers.table.headers.company") },
      {
        selector: "businessId",
        name: t("providers.table.headers.identification"),
      },
      { selector: "type", name: t("providers.table.headers.action") },
      {
        selector: "applicationDate",
        name: t("providers.table.headers.requestDate"),
      },
      { selector: "state", name: t("providers.table.headers.invitationState") },
      {
        selector: "actions",
        name: t("providers.table.headers.action"),
        center: true,
        cellFormatter: (row) => (
          <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel",
              },
            }}
            isMenuOpen={menu[`menu-${row.item.id}`] || false}
            setIsMenuOpen={(open) => handleMenu(row.item.id, open)}
          >
            <ActionMenuListItem
              icon={() => (
                <IconShow
                  id={`related-${row.item.id}`}
                  className="TextButton__icon--left"
                />
              )}
              onClick={() => handleMenu(row.item.id, false)}
              link={{
                href: `/providers/provider/detail/${row.item.providerId}/${row.item.requestType}/${row.currency}`,
              }}
            >
              {t("general.labels.fileModal.detail")}
            </ActionMenuListItem>
          </ActionMenuList>
        ),
      }
    );

    return headers;
  };

  const selectAll = (checked, allId) => {
    const tmpSelected = new Set(selected);
    const tmpAllSelect = new Set(allSelect);

    if (checked === false) {
      tmpAllSelect.delete(allId);
    } else {
      tmpAllSelect.add(allId);
    }

    data.content.forEach((item) => {
      if (item.requestType !== "ADDITION") {
        if (checked === false) {
          tmpSelected.delete(`id-${item.id}`);
        } else {
          tmpSelected.add(`id-${item.id}`);
        }
      }
    });

    setAllSelect(tmpAllSelect);
    setSelected(tmpSelected);
  };

  const changeSelection = (check, id) => {
    const tmpSelected = new Set(selected);
    if (check === false) {
      tmpSelected.delete(id);
    } else {
      tmpSelected.add(id);
    }

    setSelected(tmpSelected);
  };

  const getData = () => {
    let result = [];

    if (data.content && data.content.length > 0) {
      data.content.map((item) =>
        result.push({
          companyId: item.companyId,
          company: item.companyName,
          businessId: item.businessId,
          type: t(`general.relationTypes.${item.requestType}`),
          applicationDate: item.applicationDate,
          currency: item.currency,
          state:
            item.invitationStatus !== null &&
            item.invitationStatus !== undefined
              ? t(`general.inviteStates.${item.invitationStatus}`)
              : "",
          item,
        })
      );
    }

    return result;
  };

  /*const getDetail = (row) => {
    company.current = row.item.id;
    handleMenu(row.item.id, false);
  };*/

  const search = (type, value) => {
    let querystring = "";
    let selectedFilter = filters.filter((item) => item.property === type);

    if (selectedFilter.length > 0) {
      querystring = `&search=${type}/${selectedFilter[0].operator}/${value}`;
    }

    getList({ page: 0, sizePerPage: 10, querystring });
  };

  /*const goBack = (reload = false) => {
    company.current = 0;
    setDetail(false);
    if (reload) {
      getList({ page: 0, sizePerPage: pagination.sizePerPage });
    }
  };*/

  const masiveApproveOrReject = (approve) => {
    let data = [];
    selected.forEach((item) => data.push({ approve, id: item.split("-")[1] }));

    doApproveOrReject(data).then(() =>
      getList({ page: 0, sizePerPage: pagination.sizePerPage })
    );
  };

  const doApproveOrReject = (data) => {
    setLoading(true);
    return postApiCAll(
      `providers/additions-modifications-accouts-csa/approve-or-rejected`,
      data,
      {}
    )
      .then((response) => {
        setLoading(false);
        getModalResponse(response.data);
      })
      .catch(() => {
        setLoading(false);
        let button = {
          formBtn: {
            text: "Cerrar",
            action: () => {
              setModal({
                show: false,
                ontent: null,
                onClose: undefined,
              });
            },
          },
        };
        let content = sucessInfoModal(
          "Adiciones/Modificaciones",
          "Ha ocurrido un error inesperado, favor intente mas tarde",
          button
        );
        setModal({
          show: true,
          content,
          onClose: () => history.replace("/providers"),
        });
      });
  };

  const getActions = () => {
    const { rejected, approve } = t("general.buttons", { returnObjects: true });

    return moduleAction(roles, MOD_DISCONT_PROV, EXECUTE) &&
      selected.size > 0 ? (
      <div className="form-actions clearfix">
        <SecondaryButton onClick={() => masiveApproveOrReject(false)}>
          {rejected}
        </SecondaryButton>
        <SecondaryButton onClick={() => masiveApproveOrReject(true)}>
          {approve}
        </SecondaryButton>
      </div>
    ) : null;
  };

  return (
    <>
      <>
        <div className="flex-element left-flex">
          <FilterComponent filter={filters} searchFnc={search} />
        </div>
        <Table
          headers={getHeaders()}
          data={getData()}
          totalSize={data.totalElements}
          sizePerPage={pagination.sizePerPage}
          page={pagination.page}
          onTableChange={getList}
          actions={getActions()}
        />
      </>

      <Modal show={loading}>{loadingHtml()}</Modal>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default ProviderAditionalModify;
